/* Swish Court Builder tile-series helpers.
   Keep this file free of DOM, builder state, and render dependencies so it can
   be loaded before the main builder entry and reused by future split assets.
*/
var swishcbTilesGlobal = (typeof window !== 'undefined')
  ? window
  : ((typeof globalThis !== 'undefined') ? globalThis : {});

/* __SWISHCB_TILE_HELPERS_START__ */
// Pure helpers used by Node tests + runtime tile math.
var swishcb_tiles_SPECS = {
  elastic: { id: 'elastic', label: 'Elastic Tiles', tileM: 0.303, edgeM: 0.0725 },
  elite: { id: 'elite', label: 'Elite Tiles', tileM: 0.305, edgeM: 0.08 },
  'large-elite': { id: 'large-elite', label: 'Large Elite Tiles', tileM: 0.5, edgeM: 0.05 }
};
function swishcb_tiles_normalizeSeriesId(v) {
  var s = String(v == null ? '' : v).trim().toLowerCase();
  if (s === 'elite') return 'elite';
  if (s === 'large-elite' || s === 'large_elite' || s === 'largeelite' || s === 'large elite') return 'large-elite';
  if (s === 'elastic') return 'elastic';
  return 'elastic';
}
function swishcb_tiles_getSpec(seriesId) {
  var key = swishcb_tiles_normalizeSeriesId(seriesId);
  return swishcb_tiles_SPECS[key] || swishcb_tiles_SPECS.elastic;
}
function swishcb_tiles_getTileCountBounds(minM, maxM, seriesId) {
  var spec = swishcb_tiles_getSpec(seriesId);
  var tile = Number(spec.tileM) || 0;
  var rawMin = tile > 0 ? Math.ceil(Number(minM) / tile) : 0;
  var rawMax = tile > 0 ? Math.floor(Number(maxM) / tile) : 0;
  var minCount = Math.max(0, rawMin);
  var maxCount = Math.max(minCount, rawMax);
  return { minCount: minCount, maxCount: maxCount, spec: spec };
}
function swishcb_tiles_snapToBoundsMeters(totalM, minM, maxM, seriesId) {
  var bounds = swishcb_tiles_getTileCountBounds(minM, maxM, seriesId);
  var minCount = bounds.minCount;
  var maxCount = bounds.maxCount;
  var spec = bounds.spec;
  var tile = Number(spec.tileM) || 0;
  var edge = Number(spec.edgeM) || 0;
  var rawCount = tile > 0 ? Math.round(Number(totalM) / tile) : 0;
  var count = Math.max(minCount, Math.min(maxCount, rawCount));
  var snapped = count * tile;
  return { totalM: snapped, tiles: count, tileM: tile, edgeM: edge, spec: spec };
}
function swishcb_tiles_snapToContainBoundsMeters(totalM, minM, maxM, seriesId) {
  var bounds = swishcb_tiles_getTileCountBounds(minM, maxM, seriesId);
  var minCount = bounds.minCount;
  var maxCount = bounds.maxCount;
  var spec = bounds.spec;
  var tile = Number(spec.tileM) || 0;
  var edge = Number(spec.edgeM) || 0;
  var rawCount = tile > 0 ? Math.ceil((Number(totalM) - 1e-9) / tile) : 0;
  var count = Math.max(minCount, Math.min(maxCount, rawCount));
  var snapped = count * tile;
  return { totalM: snapped, tiles: count, tileM: tile, edgeM: edge, spec: spec };
}
function swishcb_tiles_countFromMeters(totalM, seriesId) {
  var spec = swishcb_tiles_getSpec(seriesId);
  var tile = Number(spec.tileM) || 0;
  var raw = tile > 0 ? Math.round(Number(totalM) / tile) : 0;
  return Math.max(0, raw);
}
function swishcb_tiles_resolveAspectLockedCounts(options) {
  var opts = options && typeof options === 'object' ? options : {};
  var spec = opts.spec && typeof opts.spec === 'object'
    ? opts.spec
    : swishcb_tiles_getSpec(opts.seriesId || 'elastic');
  var tile = Number(spec && spec.tileM) || 0;
  if (!(tile > 0)) return null;
  var officialLengthM = Number(opts.officialLengthM);
  var officialWidthM = Number(opts.officialWidthM);
  if (!Number.isFinite(officialLengthM) || !Number.isFinite(officialWidthM) || !(officialLengthM > 0) || !(officialWidthM > 0)) return null;
  var lengthBounds = swishcb_tiles_getTileCountBounds(
    Number.isFinite(Number(opts.minLengthM)) ? Number(opts.minLengthM) : 0,
    Number.isFinite(Number(opts.maxLengthM)) ? Number(opts.maxLengthM) : Infinity,
    spec.id
  );
  var widthBounds = swishcb_tiles_getTileCountBounds(
    Number.isFinite(Number(opts.minWidthM)) ? Number(opts.minWidthM) : 0,
    Number.isFinite(Number(opts.maxWidthM)) ? Number(opts.maxWidthM) : Infinity,
    spec.id
  );
  var clampCount = function(value, minCount, maxCount) {
    var raw = Math.max(0, Math.round(Number(value) || 0));
    return Math.max(minCount, Math.min(maxCount, raw));
  };
  var countForRequested = function(requestedM, officialM, minCount, maxCount) {
    var requested = Number(requestedM);
    if (!Number.isFinite(requested)) requested = officialM;
    var raw = requested + 1e-9 >= officialM
      ? Math.ceil((requested - 1e-9) / tile)
      : Math.round(requested / tile);
    return clampCount(raw, minCount, maxCount);
  };
  var officialLengthTiles = Math.max(1, Math.ceil((officialLengthM - 1e-9) / tile));
  var officialWidthTiles = Math.max(1, Math.ceil((officialWidthM - 1e-9) / tile));
  officialLengthTiles = clampCount(officialLengthTiles, lengthBounds.minCount, lengthBounds.maxCount);
  officialWidthTiles = clampCount(officialWidthTiles, widthBounds.minCount, widthBounds.maxCount);
  var requestedLengthTiles = countForRequested(opts.lengthM, officialLengthM, lengthBounds.minCount, lengthBounds.maxCount);
  var requestedWidthTiles = countForRequested(opts.widthM, officialWidthM, widthBounds.minCount, widthBounds.maxCount);
  var anchorAxis = String(opts.anchorAxis || '').trim().toLowerCase();
  var lengthTiles;
  var widthTiles;
  if (anchorAxis === 'length') {
    lengthTiles = requestedLengthTiles;
    widthTiles = clampCount(
      lengthTiles * (officialWidthTiles / Math.max(1, officialLengthTiles)),
      widthBounds.minCount,
      widthBounds.maxCount
    );
  } else if (anchorAxis === 'width') {
    widthTiles = requestedWidthTiles;
    lengthTiles = clampCount(
      widthTiles * (officialLengthTiles / Math.max(1, officialWidthTiles)),
      lengthBounds.minCount,
      lengthBounds.maxCount
    );
  } else {
    var lengthScale = requestedLengthTiles / Math.max(1, officialLengthTiles);
    var widthScale = requestedWidthTiles / Math.max(1, officialWidthTiles);
    var scale = Math.max(0, lengthScale, widthScale);
    var roundScaled = scale > 1 + 1e-9 ? Math.ceil : Math.round;
    lengthTiles = clampCount(
      roundScaled(officialLengthTiles * scale - (scale > 1 + 1e-9 ? 1e-9 : 0)),
      lengthBounds.minCount,
      lengthBounds.maxCount
    );
    widthTiles = clampCount(
      roundScaled(officialWidthTiles * scale - (scale > 1 + 1e-9 ? 1e-9 : 0)),
      widthBounds.minCount,
      widthBounds.maxCount
    );
  }
  return {
    tileM: tile,
    edgeM: Number(spec && spec.edgeM) || 0,
    tileSeries: spec ? spec.id : null,
    officialLengthTiles: officialLengthTiles,
    officialWidthTiles: officialWidthTiles,
    requestedLengthTiles: requestedLengthTiles,
    requestedWidthTiles: requestedWidthTiles,
    lengthTiles: lengthTiles,
    widthTiles: widthTiles,
    lengthM: lengthTiles * tile,
    widthM: widthTiles * tile,
    lengthBounds: lengthBounds,
    widthBounds: widthBounds,
    aligned: true
  };
}
function swishcb_tiles_normalizeKeyAlignmentMode(value) {
  var mode = String(value == null ? '' : value).trim().toLowerCase();
  if (mode === 'official' || mode === 'official-key' || mode === 'official_key') return 'official';
  if (
    mode === 'official-colored' ||
    mode === 'official_colored' ||
    mode === 'official-color' ||
    mode === 'official_color' ||
    mode === 'official-key-colored' ||
    mode === 'official_key_colored' ||
    mode === 'colored-official' ||
    mode === 'colored_official'
  ) return 'official-colored';
  if (
    mode === 'match' ||
    mode === 'match-tiles' ||
    mode === 'match_tiles' ||
    mode === 'matchtiles'
  ) return 'match';
  if (
    mode === 'expand' ||
    mode === 'custom' ||
    mode === 'custom-key' ||
    mode === 'custom_key'
  ) return 'expand';
  return 'official';
}
function swishcb_tiles_snapThicknessUpMeters(valueM, seriesId, minM) {
  if (minM === undefined) minM = 0;
  var spec = swishcb_tiles_getSpec(seriesId);
  var tile = Number(spec && spec.tileM);
  var raw = Math.max(Number(minM) || 0, Number(valueM) || 0);
  if (!Number.isFinite(tile) || tile <= 0) return raw;
  if (!(raw > 0)) return 0;
  return Math.max(tile, Math.ceil((raw - 1e-9) / tile) * tile);
}
function swishcb_tiles_snapThicknessNearestMeters(valueM, seriesId, minM) {
  if (minM === undefined) minM = 0;
  var spec = swishcb_tiles_getSpec(seriesId);
  var tile = Number(spec && spec.tileM);
  var raw = Math.max(0, Number(valueM) || 0);
  var minSafe = Math.max(0, Number(minM) || 0);
  if (!Number.isFinite(tile) || tile <= 0) return Math.max(minSafe, raw);
  if (!(raw > 0)) return 0;
  var count = Math.max(1, Math.round(raw / tile));
  return Math.max(swishcb_tiles_snapThicknessUpMeters(minSafe, seriesId, minSafe), count * tile);
}
function swishcb_tiles_snapRangeToGrid(startM, endM, axisTotalM, seriesId, modeRaw) {
  var spec = swishcb_tiles_getSpec(seriesId);
  var tile = Number(spec && spec.tileM);
  var edge = Number(spec && spec.edgeM) || 0;
  var total = Math.max(0, Number(axisTotalM) || 0);
  if (!Number.isFinite(tile) || tile <= 0 || !(total > 0)) return null;
  var count = swishcb_tiles_countFromMeters(total, spec.id);
  if (!(count > 0)) return null;
  var gridStart = 0;
  var gridEnd = count * tile;
  var rawStartInput = Math.min(Number(startM) || 0, Number(endM) || 0);
  var rawEndInput = Math.max(Number(startM) || 0, Number(endM) || 0);
  var gridSnapToleranceM = Math.min(0.005, Math.max(0.001, tile * 0.02));
  var snapNearGridLine = function(value) {
    var rawIndex = (Number(value) - gridStart) / tile;
    var nearestIndex = Math.max(0, Math.min(count, Math.round(rawIndex)));
    var nearestValue = gridStart + (nearestIndex * tile);
    return Math.abs(Number(value) - nearestValue) <= gridSnapToleranceM ? nearestValue : Number(value);
  };
  var rawStart = snapNearGridLine(rawStartInput);
  var rawEnd = snapNearGridLine(rawEndInput);
  var mode = swishcb_tiles_normalizeKeyAlignmentMode(modeRaw);
  var startIndex;
  var endIndex;
  if (mode === 'shift') {
    var rawSpan = Math.max(0, rawEnd - rawStart);
    var spanCount = Math.max(1, Math.min(count, Math.round(rawSpan / tile)));
    var centerIndex = ((rawStart + rawEnd) * 0.5 - gridStart) / tile;
    startIndex = Math.round(centerIndex - (spanCount * 0.5));
    startIndex = Math.max(0, Math.min(count - spanCount, startIndex));
    endIndex = startIndex + spanCount;
  } else {
    startIndex = Math.floor(((rawStart - gridStart) / tile) + 1e-9);
    endIndex = Math.ceil(((rawEnd - gridStart) / tile) - 1e-9);
    startIndex = Math.max(0, Math.min(count, startIndex));
    endIndex = Math.max(startIndex + 1, Math.min(count, endIndex));
    if (endIndex > count) {
      endIndex = count;
      startIndex = Math.max(0, Math.min(startIndex, endIndex - 1));
    }
  }
  var snappedStart = gridStart + (startIndex * tile);
  var snappedEnd = gridStart + (endIndex * tile);
  return {
    startM: snappedStart,
    endM: snappedEnd,
    distanceM: Math.max(0, snappedEnd - snappedStart),
    startTile: startIndex,
    endTile: endIndex,
    tileCount: Math.max(0, endIndex - startIndex),
    tileM: tile,
    edgeM: edge,
    tileSeries: spec.id,
    mode: mode,
    gridStartM: gridStart,
    gridEndM: gridEnd,
    aligned: true
  };
}
function swishcb_tiles_snapFixedCountRangeToGrid(startM, endM, axisTotalM, seriesId, spanTileCount, anchorRaw) {
  if (anchorRaw === undefined) anchorRaw = 'center';
  var spec = swishcb_tiles_getSpec(seriesId);
  var tile = Number(spec && spec.tileM);
  var edge = Number(spec && spec.edgeM) || 0;
  var total = Math.max(0, Number(axisTotalM) || 0);
  if (!Number.isFinite(tile) || tile <= 0 || !(total > 0)) return null;
  var count = swishcb_tiles_countFromMeters(total, spec.id);
  if (!(count > 0)) return null;
  var requestedTileCount = Math.max(1, Math.round(Number(spanTileCount) || 0));
  var tileCount = Math.max(1, Math.min(count, requestedTileCount));
  var gridStart = 0;
  var gridEnd = count * tile;
  var rawStart = Math.min(Number(startM) || 0, Number(endM) || 0);
  var rawEnd = Math.max(Number(startM) || 0, Number(endM) || 0);
  var anchor = String(anchorRaw || '').trim().toLowerCase();
  var startIndex;
  if (anchor === 'start') {
    startIndex = Math.round((rawStart - gridStart) / tile);
  } else if (anchor === 'end') {
    var endIndexRaw = Math.round((rawEnd - gridStart) / tile);
    startIndex = endIndexRaw - tileCount;
  } else {
    var centerIndex = (((rawStart + rawEnd) * 0.5) - gridStart) / tile;
    startIndex = Math.round(centerIndex - (tileCount * 0.5));
  }
  startIndex = Math.max(0, Math.min(count - tileCount, startIndex));
  var endIndex = startIndex + tileCount;
  var snappedStart = gridStart + (startIndex * tile);
  var snappedEnd = gridStart + (endIndex * tile);
  return {
    startM: snappedStart,
    endM: snappedEnd,
    distanceM: Math.max(0, snappedEnd - snappedStart),
    startTile: startIndex,
    endTile: endIndex,
    tileCount: tileCount,
    requestedTileCount: requestedTileCount,
    reduced: tileCount < requestedTileCount,
    tileM: tile,
    edgeM: edge,
    tileSeries: spec.id,
    anchor: anchor === 'start' || anchor === 'end' ? anchor : 'center',
    gridStartM: gridStart,
    gridEndM: gridEnd,
    aligned: true
  };
}
function swishcb_tiles_expandCenteredTileCountForAxis(spanTileCount, axisTotalM, seriesId) {
  var spec = swishcb_tiles_getSpec(seriesId);
  var tile = Number(spec && spec.tileM);
  var axisCount = swishcb_tiles_countFromMeters(axisTotalM, spec && spec.id);
  if (!Number.isFinite(tile) || tile <= 0 || !(axisCount > 0)) {
    return Math.max(1, Math.round(Number(spanTileCount) || 0));
  }
  var count = Math.max(1, Math.min(axisCount, Math.round(Number(spanTileCount) || 0)));
  if (count < axisCount && Math.abs((axisCount - count) % 2) === 1) count += 1;
  return Math.max(1, Math.min(axisCount, count));
}
function swishcb_tiles_formatMeasurementLabel(totalM, seriesId, unitRaw) {
  var spec = swishcb_tiles_getSpec(seriesId);
  var FT_PER_M = 3.280839895;
  var unit = (String(unitRaw || '').toLowerCase() === 'ft') ? 'ft' : 'm';
  var tileDisp = unit === 'ft' ? (spec.tileM * FT_PER_M) : spec.tileM;
  var tiles = swishcb_tiles_countFromMeters(totalM, seriesId);
  var fmtTrim = function(n, maxDecimals) {
    if (maxDecimals === undefined) maxDecimals = 4;
    var num = Number(n);
    if (!Number.isFinite(num)) return '0';
    var s = num.toFixed(maxDecimals);
    return s.replace(/\.?0+$/, '');
  };
  var decimalPlaces = function(text) {
    var match = String(text == null ? '' : text).match(/\.(\d+)/);
    return match ? match[1].length : 0;
  };
  var fmtComponentTotal = function(n, decimals) {
    var num = Number(n);
    var safeDecimals = Math.max(0, Math.min(6, Number(decimals) || 0));
    if (!Number.isFinite(num)) return '0';
    var s = num.toFixed(safeDecimals);
    return s.replace(/\.?0+$/, '') || '0';
  };
  var tileTxt = fmtTrim(tileDisp, 4);
  var tileShown = Number(tileTxt);
  var totalTxt = Number.isFinite(tileShown)
    ? fmtComponentTotal(tiles * tileShown, decimalPlaces(tileTxt))
    : fmtComponentTotal(unit === 'ft' ? (Number(totalM) * FT_PER_M) : Number(totalM), 4);
  return totalTxt + ' ' + unit + ' / ' + tiles + ' pcs × ' + tileTxt + ' ' + unit + ' ' + spec.label;
}
/* __SWISHCB_TILE_HELPERS_END__ */

try {
  swishcbTilesGlobal.swishcb_tiles_normalizeSeriesId = swishcb_tiles_normalizeSeriesId;
  swishcbTilesGlobal.swishcb_tiles_getSpec = swishcb_tiles_getSpec;
  swishcbTilesGlobal.swishcb_tiles_getTileCountBounds = swishcb_tiles_getTileCountBounds;
  swishcbTilesGlobal.swishcb_tiles_snapToBoundsMeters = swishcb_tiles_snapToBoundsMeters;
  swishcbTilesGlobal.swishcb_tiles_snapToContainBoundsMeters = swishcb_tiles_snapToContainBoundsMeters;
  swishcbTilesGlobal.swishcb_tiles_countFromMeters = swishcb_tiles_countFromMeters;
  swishcbTilesGlobal.swishcb_tiles_resolveAspectLockedCounts = swishcb_tiles_resolveAspectLockedCounts;
  swishcbTilesGlobal.swishcb_tiles_normalizeKeyAlignmentMode = swishcb_tiles_normalizeKeyAlignmentMode;
  swishcbTilesGlobal.swishcb_tiles_snapThicknessUpMeters = swishcb_tiles_snapThicknessUpMeters;
  swishcbTilesGlobal.swishcb_tiles_snapThicknessNearestMeters = swishcb_tiles_snapThicknessNearestMeters;
  swishcbTilesGlobal.swishcb_tiles_snapRangeToGrid = swishcb_tiles_snapRangeToGrid;
  swishcbTilesGlobal.swishcb_tiles_snapFixedCountRangeToGrid = swishcb_tiles_snapFixedCountRangeToGrid;
  swishcbTilesGlobal.swishcb_tiles_expandCenteredTileCountForAxis = swishcb_tiles_expandCenteredTileCountForAxis;
  swishcbTilesGlobal.swishcb_tiles_formatMeasurementLabel = swishcb_tiles_formatMeasurementLabel;
  swishcbTilesGlobal.__swishcbTilesScriptReady = true;
} catch (e) {}
